/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readability Analyzer`)
};

const es_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizador de Legibilidad`)
};

const de_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesbarkeitsanalyse`)
};

const nl_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leesbaarheidsanalisator`)
};

const fr_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseur de lisibilité`)
};

const it_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizzatore di Leggibilità`)
};

const pt_br2_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisador de Legibilidade`)
};

const pt_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisador de Legibilidade`)
};

const ja_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読みやすさ分析ツール`)
};

const zh_ra_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可读性分析工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_tool_name", locale)
	if (locale === "en") return en_ra_tool_name(inputs)
	if (locale === "es") return es_ra_tool_name(inputs)
	if (locale === "de") return de_ra_tool_name(inputs)
	if (locale === "nl") return nl_ra_tool_name(inputs)
	if (locale === "fr") return fr_ra_tool_name(inputs)
	if (locale === "it") return it_ra_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_ra_tool_name(inputs)
	if (locale === "pt") return pt_ra_tool_name(inputs)
	if (locale === "ja") return ja_ra_tool_name(inputs)
	return zh_ra_tool_name(inputs)
};